import Axios from 'axios';
import header from './auth/header'

const API_URL = process.env.API_URL + '/api/v3';

class Agreement {
	/**
	 * Get the currently active SNK content.
	 * GET /v3/content-snk/active
	 */
	getActiveSnk() {
		return Axios.get(API_URL + '/content-snk/active');
	}

	/**
	 * Get the currently active Kebijakan Privasi content.
	 * GET /v3/content-privacy/active
	 */
	getActivePrivacy() {
		return Axios.get(API_URL + '/content-privacy/active');
	}

	/**
	 * Get current user eFunding agreement status.
	 * GET /v3/users/agreement/current
	 */
	getCurrentAgreement() {
		return Axios.get(API_URL + '/users/agreement/current', { headers: header() });
	}

	/**
	 * Store eFunding agreement for the current user.
	 * POST /v3/users/agreement/
	 */
	storeAgreement(data = {}) {
		return Axios.post(API_URL + '/users/agreement/', data, { headers: header() });
	}

	/**
	 * Get current user Kebijakan Privasi agreement status.
	 * GET /v3/users/privacy/agreement/current
	 */
	getCurrentPrivacyAgreement() {
		return Axios.get(API_URL + '/users/privacy/agreement/current', { headers: header() });
	}

	/**
	 * Store Kebijakan Privasi agreement for the current user.
	 * POST /v3/users/privacy/agreement/
	 */
	storePrivacyAgreement(data = {}) {
		return Axios.post(API_URL + '/users/privacy/agreement/', data, { headers: header() });
	}

	/**
	 * Get current user Tilaka agreement status.
	 * GET /v3/users/tilaka/agreement/current
	 */
	getCurrentTilakaAgreement() {
		return Axios.get(API_URL + '/users/tilaka/agreement/current', { headers: header() });
	}

	/**
	 * Store Tilaka agreement for the current user.
	 * POST /v3/users/tilaka/agreement/
	 */
	storeTilakaAgreement(data = {}) {
		return Axios.post(API_URL + '/users/tilaka/agreement/', data, { headers: header() });
	}
}

export default new Agreement();



// WEBPACK FOOTER //
// ./src/api/agreement.js